<script setup>
import { STEPS } from '../../constants/steps';
import { useSubmitStore } from '../../stores/submit.js';
import { useUiStore } from '../../stores/ui.js';
import Icon from '../Icon.vue';

const uiStore = useUiStore();
const submitStore = useSubmitStore();

function goToStep(step){
    if(!uiStore.visitedSteps.includes(step)){
        return;
    }

    uiStore.goToStep(step);
}
</script>

<template>
    <div
        class="ConfiguratorFormHeader tw-sticky tw-top-0 tw-bg-white tw-text-sm tw-text-gray-300 tw-transition-all tw-duration-300"
        :class="!uiStore.isScrollingUp && 'lg:tw-translate-y-0' + (uiStore.currentStepIndex === STEPS.length - 1 ? 'tw-z-0' : '-tw-translate-y-1/2 tw-z-30')"
        v-if="!submitStore.isFinished"
    >
        <div class="tw-relative lg:tw-h-auto tw-transition-all tw-duration-300 lg:tw-pr-11 xxl:tw-pr-16">
            <div class="ConfiguratorSteps tw-flex tw-w-full tw-relative tw-px-3 md:tw-px-5 xxl:tw-p-0 lg:tw-mt-8 xxl:tw-mt-12 xxl:tw-pl-8 xxl:tw-pr-6 lg:tw-mb-4 xxl:tw-mb-6 tw-py-4 tw-h-[68px] lg:tw-h-auto">
                <div class="ConfiguratorStepsProgress tw-block tw-h-px tw-bg-gray-100 tw-absolute tw-top-1/2 tw-left-5 tw-right-5 md:tw-left-8 md:tw-right-8 lg:tw-left-10 lg:tw-right-10">
                    <div
                        class="ConfiguratorStepsProgressBar tw-h-px tw-bg-brand-500 tw-transition-[width] tw-duration-500 tw-ease-in-out"
                        :style="{ width: ((100 / (STEPS.length - 1)) * uiStore.currentStepIndex) + '%' }"
                    ></div>
                </div>

                <div
                    class="step"
                    v-for="step in STEPS"
                    :key="step"
                    :class="{ 'active': step === uiStore.currentStep, 'done': uiStore.visitedSteps.includes(step) }"
                    @click="goToStep(step)"
                ></div>
            </div>
        </div>
    </div>
</template>